import React, { useMemo } from 'react'

import { Box } from '@gousto-internal/citrus-react'
import Helmet from 'react-helmet'
import useSWR from 'swr'

import { RafLandingPage } from '@features/raf-landing-page'
import { fromAPIRecipe, menuFetcherV3 } from '@library/menu-service'
import type { Recipe } from '@library/menu-service'
import type { Menu } from '@library/menu-service/queries/menuApiMenu/types'

import { useGetCtaProps } from 'routes/Home/Cta'
import { onScrollHandler } from 'routes/Home/Hero/heroUtils'

import { seo } from './seoConfig'
import { useHandleSignupCTAClick } from './utils'

export const RafPage = () => {
  const handleSignupCTAClick = useHandleSignupCTAClick()

  const { data: menuResponse } = useSWR(
    {
      numPortions: 2,
    },
    menuFetcherV3,
  )

  const formatRecipes = (response?: Menu): Recipe[] => {
    if (!response || !response.recipes) {
      return []
    }

    return Object.values(response.recipes).map((recipe) => fromAPIRecipe(recipe))
  }

  const recipes = useMemo(() => formatRecipes(menuResponse), [menuResponse])

  const { ctaText } = useGetCtaProps()

  return (
    <Box>
      <Helmet title={seo.title} meta={seo.meta} />
      <RafLandingPage
        onScrollHandler={onScrollHandler}
        onSignupCTAClick={handleSignupCTAClick}
        recipes={recipes}
        signupCTA={ctaText}
      />
    </Box>
  )
}
